<router-outlet></router-outlet>
<app-message #message></app-message>
<ngx-loading-bar></ngx-loading-bar>

